export default "__VITE_ASSET__Oywvs6uh__"